<template>
  <v-layout column>
    <v-flex pl-2 xs12>
      <h4>Search Ratings</h4>
    </v-flex>
    <v-layout xs12 pt-2 class="search-fields" column>
      <form v-on:keyup.enter="search">
        <v-rating dense v-model="query.rating" clearable></v-rating>
        <div style="padding-top: 12px; height: 1px;"></div>
        <v-checkbox v-model="query.customerToDriver" :label="`Customer to Driver`"></v-checkbox>
        <v-row>
          <v-flex shrink pr-3>
            <v-btn @click="search" color="blue" dark class="text-none">Search</v-btn>
          </v-flex>
          <v-flex shrink>
            <v-btn @click="clear" class="text-none">Clear</v-btn>
          </v-flex>
        </v-row>
      </form>
    </v-layout>
  </v-layout>
</template>

<script>
import moment from "moment";

export default {
  name: "rating_search_box",
  props: {
    query: Object,
  },
  data: function () {
    return {};
  },
  methods: {
    search: function () {
      this.$emit("search");
    },
    clear: function () {
      this.$emit("clear");
    },
  },
  components: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}

.search-fields {
  padding-left: 6px;
  padding-right: 6px;
}
</style>
